import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/wall/')({
  beforeLoad: () => {
    throw redirect({ to: '/wall/contact' });
  },
});
